import React, { useState } from "react";

const Contact = ({ data }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  if (!data) {
    return null;
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    const body = `${name} (${email})\n\n${message}`;
    window.location.href = `mailto:${data.email}?subject=${encodeURIComponent(
      subject || "Portfolio enquiry"
    )}&body=${encodeURIComponent(body)}`;
  };

  return (
    <section id="contact" className="contact-section section-shell">
      <div className="contact-intro" data-reveal>
        <p className="section-kicker">Contact</p>
        <h2>Build something that needs to work when it matters.</h2>
        <p>{data.contactmessage}</p>

        <div className="contact-details">
          <a href={`mailto:${data.email}`}>{data.email}</a>
          <a href={`tel:${data.phone.replace(/\s/g, "")}`}>{data.phone}</a>
          <span>{data.address.city}, Nigeria</span>
        </div>
      </div>

      <form
        className="contact-form"
        onSubmit={handleSubmit}
        data-reveal
        style={{ "--reveal-delay": "100ms" }}
      >
        <div className="form-row">
          <label htmlFor="contactName">
            Name
            <input
              id="contactName"
              name="contactName"
              type="text"
              value={name}
              onChange={(event) => setName(event.target.value)}
              required
            />
          </label>
          <label htmlFor="contactEmail">
            Email
            <input
              id="contactEmail"
              name="contactEmail"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>
        </div>

        <label htmlFor="contactSubject">
          What are you working on?
          <input
            id="contactSubject"
            name="contactSubject"
            type="text"
            value={subject}
            onChange={(event) => setSubject(event.target.value)}
          />
        </label>

        <label htmlFor="contactMessage">
          Message
          <textarea
            id="contactMessage"
            name="contactMessage"
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            rows="5"
            required
          />
        </label>

        <button className="button button-primary" type="submit">
          Send email
        </button>
      </form>
    </section>
  );
};

export default Contact;
